import { Helmet } from "react-helmet-async"
import { useConsole } from "contexts/Console"
import { useLocale } from "contexts/Locale"
import { useNavigation } from "contexts/Navigation"

export default function HelmetConfig({ children, initialState }) {
  const console = useConsole()
  const locale = useLocale()
  const country = locale.current.codes.country
  const navigation = useNavigation()
  // const regionNames = new Intl.DisplayNames([locale.current.codes.ws], { type: "region" })
  let { default_title = "", title_template = "%s" } = initialState[locale.current.codes.www]?.meta ?? {}


  if (country) {
    const addon = navigation.slug === "/" ? locale.current.label : locale.current.codes.country
    if (locale.current.dir === "rtl") {
      title_template = `(${addon}) ${title_template}`
    }
    else {
      title_template += ` (${addon})`
    }
  }

  console.verbose("Helmet(%o)", { lang: locale.current.codes.ws, dir: locale.current.dir, default_title, title_template, slug: navigation.slug })
  return (
    <>
      <Helmet defaultTitle={default_title} defer={false} titleTemplate={title_template} encodeSpecialCharacters={false}>
        <html lang={locale.current.codes.ws} dir={locale.current.dir} />
      </Helmet>
      {children}
    </>
  )
}
